<template>
	<span
		v-if="tooltipText.length > 0"
		v-tooltip.top="{
			value: formattedTooltip,
			escape: false,
		}"
		class="inline-flex items-center cursor-help"
	>
		<FontAwesomeIcon
			:icon="['far', iconName]"
			:class="iconClass"
			:size="size"
		/>
	</span>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faTriangleExclamation, faCircleExclamation } from "@fortawesome/pro-regular-svg-icons"

library.add(faTriangleExclamation, faCircleExclamation)

const props = defineProps({
	errorType: {
		type: String as PropType<"Warning" | "Error">,
		required: false,
		default: "Warning",
	},
	tooltipText: {
		type: Array as PropType<string[]>,
		required: true,
		default: () => [],
	},
	size: {
		type: String as PropType<"xs" | "sm" | "lg" | "xl" | "2x" | "3x">,
		required: false,
		default: "lg",
	},
})

const iconName = computed(() => {
	return props.errorType === "Error" ? "circle-exclamation" : "triangle-exclamation"
})

const iconClass = computed(() => {
	return props.errorType === "Error" ? "text-red-600" : "text-yellow-600"
})

const formattedTooltip = computed(() => {
	if (props.tooltipText.length === 1) {
		return props.tooltipText[0]
	}
	return `<ul class="list-disc pl-4 m-0">${props.tooltipText.map((text) => `<li>${text}</li>`).join("")}</ul>`
})
</script>

<style scoped></style>
